import type { PackId } from '../shared/game';

export const RESPAWN_PACK_SELECTION_EVENT = 'tribes2:respawn-pack-selection';

export function selectRespawnPackForInput(packId: PackId) {
  window.dispatchEvent(new CustomEvent(RESPAWN_PACK_SELECTION_EVENT, { detail: packId }));
}
